import type React from 'react';
import type { ALERT_STATUSES } from '@constants/alertNotifications.ts';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type NotificationType = (typeof ALERT_STATUSES)[keyof typeof ALERT_STATUSES];

interface Alert {
    type: NotificationType;
    description: string | React.ReactNode;
    message?: string;
}

interface AlertState {
    current: Alert | null;
}

const alertSlice = createSlice({
    name: 'alert',
    initialState: { current: null } as AlertState,
    reducers: {
        setAlert(state, action: PayloadAction<Alert>) {
            state.current = action.payload;
        },
        clearAlert(state) {
            state.current = null;
        },
    },
});

export const { setAlert, clearAlert } = alertSlice.actions;
export default alertSlice.reducer;
